import { SET_SAVED_SEARCH } from '../actions/saved_search';

export default function(state = {}, action) {
  switch (action.type) {
  case SET_SAVED_SEARCH:
    return action.payload;
  default:
    return state;
  }
}
